import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2
} from '@angular/core';
import {
  adobeClickEventAnalyticsMocks,
  ANALYTICS_EVENTS,
  EVENT_CLICK_TYPE
} from '@com-delta-idp/mnx-utils';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataLayer } from '../../common/datalayer/datalayer';
import { ContentFooterInfo } from '../../model/content/contentfooter.model';
import { AdobeDataLayerService } from '../../services/adobe-data-layer/adobe-data-layer';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { ContentFooterColumn } from './../../model/content/contentfootercolumn.model';

declare let delta: any;

@Component({
  selector: 'ngc-footer-column',
  templateUrl: 'footer-column.component.html'
})
export class FooterColumnComponent implements OnInit, OnDestroy {
  public contentColumn: ContentFooterColumn[];
  public columnCount: number;
  public externalImgUrl: ContentFooterInfo;
  public externalImgDesc: ContentFooterInfo;
  contentServiceHeaderFooterSubscribe: Subscription;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private contentService: ContentHeaderFooterService,
    private cdf: ChangeDetectorRef,
    private datalayer: DataLayer,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private adobeDataLayer: AdobeDataLayerService
  ) {}

  ngOnInit() {
    this.contentService._isHeaderFooter
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((headerFooterFlag) => {
        if (headerFooterFlag) {
          if (this.contentService.contentHeaderFooter) {
            this.contentServiceHeaderFooterSubscribe =
              this.contentService.contentHeaderFooter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (data) => {
                    if (data) {
                      this.columnCount = 3;
                      this.externalImgUrl = data.footer.info.externalImgPath;
                      this.externalImgDesc = data.footer.info.footerExtDesc;
                      this.contentColumn = data.footer.footercolumns;
                      this.cdf.detectChanges();
                      const elementCaption =
                        this.elementRef.nativeElement.querySelectorAll(
                          'div.caption a.icon-Dropdown-caret'
                        );
                      const captionTitle =
                        elementCaption &&
                        Array.prototype.slice.call(elementCaption);
                      if (
                        captionTitle !== null &&
                        captionTitle !== undefined &&
                        captionTitle.length > 0
                      ) {
                        captionTitle.forEach((item) => {
                          this.renderer.setAttribute(
                            item,
                            'aria-expanded',
                            'false'
                          );
                        });
                      }
                    }
                  },
                  (err) => {
                    // delta.utils.logger.logMessage('Caught Error: ' + err, 'error');
                  }
                );
          }
        }
      });
  }

  setTrackingObject(columnHeading: string, itemText: string, e: any): void {
    this.datalayer.setTrackingObjectProp1(
      'footer:' + columnHeading + ':' + itemText,
      e.target
    );

    const url = e.target.getAttribute('href') || '';
    const isUrl = url && (url.startsWith('/') || url.startsWith('http'));
    const cleanUrl = this.adobeDataLayer.removeCountryLanguageFromUrl(url);

    const data = {
      ...adobeClickEventAnalyticsMocks,
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: ANALYTICS_EVENTS.CLICK,
      click: {
        name: itemText,
        type: isUrl ? EVENT_CLICK_TYPE.LINK : EVENT_CLICK_TYPE.BUTTON,
        page_section: `footer:${columnHeading.toLowerCase()}:${itemText.toLowerCase()}`,
        action: cleanUrl
      }
    };

    this.adobeDataLayer.setUserDataInAnalytics(data);
  }

  ngOnDestroy() {
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.cdf.detach();
  }
}
